module.exports = __webpack_public_path__ + "img/hc_pro_four_8.06f34c8c.jpg";